import React from 'react';
import Calendar from '../Calendar/index.js';
import StyledCard from './components/StyledCard.jsx';
import { Beforeunload } from './components/index.js';
import PrototypeTimesheet from '../Prototype/PrototypeTimesheet.jsx';

const GprsHome = () => {
  return (
    <StyledCard>      
      <div data-test="grid-display">
        <Calendar />          
        <PrototypeTimesheet />          
      </div>
      <Beforeunload />
    </StyledCard>
  );
}

export default GprsHome;
